const securePath = process.env.REACT_APP_SECURITY_ROUTE_PATH || 'secret';

export const loginPath = `/login/${securePath}`;
export const signupPath = `/signup/${securePath}`;
export const confirmPath = `/confirm-email/${securePath}`;
export const confirmPasswordPath = `/confirm-password/${securePath}`;
export const forgetPasswordPath = `/forget-password/${securePath}`;
export const changePasswordPath = `/change-password/${securePath}`;

export const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3000/api/v1';
const rawNeoApiUrl = process.env.REACT_APP_NEO_HTTP_API_URL || 'http://localhost:3005';
// A NEO server that is down, or reachable but not answering, must fail with a
// message rather than leave the page waiting forever on an empty table.
export const neoRequestTimeoutMs = Number(process.env.REACT_APP_NEO_REQUEST_TIMEOUT_MS) || 30000;

// --- Application base path -------------------------------------------------
// The app is served under a URL prefix that varies per deployment
// (`/prod215a/`, `/stage/`, or `/` for prod). The value is injected at
// container start by the nginx entrypoint into `config.js`
// (`window.__APP_BASE_PATH__`) from the `APP_BASE_PATH` env var, so a single
// build image can be mounted under any prefix. Empty string means "served at
// root". In `npm start`/tests the default from `public/config.js` is '' (root).
const rawBasePath = (typeof window !== 'undefined' && window.__APP_BASE_PATH__) || '';
let normalizedBasePath = String(rawBasePath).trim();
if (normalizedBasePath && !normalizedBasePath.startsWith('/')) {
    normalizedBasePath = `/${normalizedBasePath}`;
}
normalizedBasePath = normalizedBasePath.replace(/\/+$/, ''); // drop trailing slash(es)

// '' (root) or '/prod215a' — used to prefix absolute URLs we build ourselves.
export const basePath = normalizedBasePath;
// React Router / history basename. Router wants '/' for root, '/prod215a' otherwise.
export const routerBasename = normalizedBasePath || '/';

// --- NEO base URL ----------------------------------------------------------
// NEO is reached through a proxy on this same host, and that proxy lives under
// the deployment base path (/prdv2/neo), not at the root. REACT_APP_NEO_HTTP_API_URL
// carries no prefix, so without this a request goes to /neo/... — the static
// site, which answers a POST with 405 rather than reaching NEO at all.
//
// Only same-origin values are rewritten. A NEO host on another origin (what the
// server registry hands back) is already absolute and is left untouched.
const withBasePath = url => {
    if (!url || !normalizedBasePath || typeof window === 'undefined') {
        return url;
    }

    try {
        const parsed = new URL(url, window.location.origin);

        if (parsed.origin !== window.location.origin) {
            return url;
        }

        if (parsed.pathname === normalizedBasePath || parsed.pathname.startsWith(normalizedBasePath + '/')) {
            return url;
        }

        parsed.pathname = normalizedBasePath + parsed.pathname;

        return parsed.toString().replace(/[/]+$/, '');
    } catch {
        return url;
    }
};

export const neoApiUrl = withBasePath(rawNeoApiUrl);

// OAuth callback must return to *this* deployment's `/oauth` route, under the
// base path. Derived at runtime from the current origin so one image works for
// every path. NOTE: each resulting URL must be whitelisted as a callback URL on
// the Cognito app client (see deployment/README).
export const cognitoRedirectUri =
    typeof window !== 'undefined'
        ? `${window.location.origin}${normalizedBasePath}/oauth`
        : process.env.REACT_APP_COGNITO_REDIRECT || '';

export const secureLoginPath = `/login/${process.env.REACT_APP_SECURITY_ROUTE_PATH}`;

export const ACCESS_TOKEN = 'DL:accessToken';
export const USER_DATA_STORAGE_ID = 'userData';
export const NEO_ACCESSES_STORAGE_ID = 'neoAccessAttributes'
// Selected NEO server, kept per browser so a reload or a new tab keeps talking
// to the same one. Holds { id, url }: the url lets the NEO client be pointed
// before the server registry has been fetched.
export const NEO_SERVER_STORAGE_ID = 'DL:neoServer'
// Per-server NEO access groups, mirroring usermeta.meta_key = 'neo' on the API.
// Cache only: the durable copy lives per user in the database.
export const NEO_SERVER_ACCESS_STORAGE_ID = 'DL:neoAccessByServer'
// The address on the Data Lake user row, as reported by GET /neo/access. NEO is
// keyed on this, and it can differ from the email in userData, which comes from
// the OAuth userinfo response.
export const NEO_USER_EMAIL_STORAGE_ID = 'DL:neoUserEmail'

export const testUserCredentials = {
    username: 'nazar.panchenko@globallogic.com',
    password: 'Nazar$Panchenko89',
};

export const testQueryParams = {
    limit: 25,
    page: 1,
};

export const requestFilterStatuses = {
    '': 'Select status',
    0: 'Done',
    1: 'Error',
};

export const reportFilterStatuses = {
    '': 'Select run result',
    0: 'Passed',
    1: 'Failed',
    2: 'Crashed',
    3: 'Initial_crash',
    4: 'Passed_has_warnings',
    5: 'Failed_ensure',
    6: 'Skipped',
};

export const reportFilterDortByUserId = {
    0: 'All',
    1: 'By user',
};

export const requestFilterLimit = {
    25: '25',
    50: '50',
    100: '100',
};

export const reportFilterLimit = {
    25: '25',
    50: '50',
    100: '100',
};

export const jenkinsFilterLimit = {
    10: '10',
    15: '15',
    20: '20',
};